module.exports = __webpack_public_path__ + "static/img/PS-NA2_80A.a833553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PS-NA2_80A.png
// module id = bQ/d
// module chunks = 1